import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ArticleSearchService } from '@self-fix/data-access';

@Injectable()
export class ArticleSearchFormFieldComponentService {
  constructor(
    private readonly articleSearchService: ArticleSearchService,
    private readonly destroyRef: DestroyRef
  ) {}

  readonly articles$ = this.articleSearchService.articles$;

  updateArticlesOptions(formValue: string): void {
    if (formValue.length >= 3) {
      this.articleSearchService
        .getArticles(formValue)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe();
    }
  }
}
